export default "__VITE_ASSET__B3Uo9xjz__"